// ********************************************************
// Backend
// Handles calling backend APIs
// ********************************************************

import axios from 'axios'
import { app } from '@/main'
import * as Security from '@/core/security'
import * as Log from '@/core/logger'
import * as DateUtil from '@/core/date'

// Will call server and will always return a result contaning these 2 fields:
// data         Contains the api result (e.g. a list of inspections)
// failed       Is false or true. If true the caller can assuem that an error message has been shown to user if server provided an error message.
export async function callApi (params, customErrorHandlingFunc = null) {
  // todo: Remove this before release to production
  if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ": Calling API '" + params.apiName + "' at " + process.env.VUE_APP_API_URL, params)

  const res = await axios.post(process.env.VUE_APP_API_URL, {
    ApiName: params.apiName,
    ApiContext: {
      Version: params.apiVersion === undefined ? '1' : params.apiVersion,
      Token: Security != null ? Security.user.token : null
    },
    InputData: params.inputData
  }).catch((error) => {
    if (customErrorHandlingFunc) {
      customErrorHandlingFunc(error)
      return {
        data: null,
        failed: true
      }
    } else {
      if (error.response != null && error.response.data != null) {
        app.$root.$message.showError(error.response.data.Message)
      } else {
        app.$root.$message.showError(error.message)
      }
      return {
        data: null,
        failed: true
      }
    }
  })
  if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ': Calling API returns:', res, params.apiName)

  if (res.data && res.data.Failed) {
    // The API call did not throw an exception, but if data has a property
    // called Failed and it is true we do the below special handling.
    // In other words, server can tell us to logout because of some situation
    // explained in the message.
    if (res.data.Message) {
      app.$root.$message.showError(res.data.Message)
      Log.log(DateUtil.getTimeSeconds(Date.now()) + ': Calling API returns:', res)
    }
    if (res.data.DoLogOut) Security.logout()
    res.failed = true
  }

  if (res.failed) {
    // Calling API failed (e.g. exception from server)
    return res
  } else {
    // Calling API success
    return {
      data: res.data.OutputData,
      failed: false
    }
  }
}

// Perhaps never use direct code to VT25 due to https:// issues (BOCH), so just remove the code. Instead we use only one call WheelLoader.GetWeight

// export async function callWK60isAliveApi (params) {
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ": Calling API 'IsAlive' at " + 'https://' + params + '/api/Cpu/IsAlive')
//   console.log('VT25 ip', 'https://' + params + '/api/Cpu/IsAlive')
//   const res = await axios.get('https://' + params + '/api/Cpu/IsAlive').catch((error) => {
//     if (error.response != null && error.response.data != null) {
//       app.$root.$message.showError(error.response.data.Message)
//     } else {
//       app.$root.$message.showError(error.message)
//     }
//     return {
//       data: null,
//       failed: true
//     }
//   })
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ': Calling API returns:', res)
//   if (res.data && res.data.Failed) {
//     if (res.data.Message) {
//       app.$root.$message.showError(res.data.Message)
//     }
//     res.failed = true
//   }
//   if (res.failed) {
//     return res
//   } else {
//     // Calling API success
//     return {
//       data: res.data,
//       failed: false
//     }
//   }
// }

// export async function callWK60weightApi (params) {
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ": Calling API 'weight' at " + 'https://' + params + '/api/Wk60WeightData/')

//   const res = await axios.get('https://' + params + '/api/Wk60WeightData/weight').catch((error) => {
//     if (error.response != null && error.response.data != null) {
//       app.$root.$message.showError(error.response.data.Message)
//     } else {
//       app.$root.$message.showError(error.message)
//     }
//     return {
//       data: null,
//       failed: true
//     }
//   })
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ': Calling API returns:', res)
//   if (res.data && res.data.Failed) {
//     if (res.data.Message) {
//       app.$root.$message.showError(res.data.Message)
//     }
//     res.failed = true
//   }
//   if (res.failed) {
//     return res
//   } else {
//     // Calling API success
//     return {
//       data: res.data,
//       failed: false
//     }
//   }
// }

// export async function callWK60ZeroWeightApi (params) {
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ": Calling API 'ZeroWeight' at " + 'https://' + params + '/api/Wk60ResetWeight/')

//   const res = await axios.get('https://' + params + '/api/Wk60ResetWeight/ZeroWeight').catch((error) => {
//     if (error.response != null && error.response.data != null) {
//       app.$root.$message.showError(error.response.data.Message)
//     } else {
//       app.$root.$message.showError(error.message)
//     }
//     return {
//       data: null,
//       failed: true
//     }
//   })
//   if (process.env.NODE_ENV === 'development') Log.log(DateUtil.getTimeSeconds(Date.now()) + ': Calling API returns:', res)
//   if (res.data && res.data.Failed) {
//     if (res.data.Message) {
//       app.$root.$message.showError(res.data.Message)
//     }
//     res.failed = true
//   }
//   if (res.failed) {
//     return res
//   } else {
//     // Calling API success
//     return {
//       data: res.data,
//       failed: false
//     }
//   }
// }
